import classNames from "classnames/bind";
import { type CSSProperties, type ForwardedRef, forwardRef, type ReactNode, useMemo } from "react";

import { QuickRankRenderableDestinations } from "../../../reducers/quickrank";
import { useQuickRankDestinations } from "../../../hooks/quickrank/useQuickRankDestinations";
import { useSyncRefs } from "../../../hooks/useSyncRefs";

export type CalculatePositionType = (index: number) => CSSProperties;

interface QuickRankDestinationProps {
  calculatePosition?: CalculatePositionType | undefined;
  kind: QuickRankRenderableDestinations.DECK | QuickRankRenderableDestinations.HAND;
  styles: CSSModuleClasses;
  wrapperChild?: ReactNode;
  destinationChild?: ReactNode;
}

export const QuickRankDestination = forwardRef(function QuickRankDestination(
  props: QuickRankDestinationProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const { kind, destinationChild, wrapperChild, styles, calculatePosition } = props;
  const { ref: contextRef, toRender } = useQuickRankDestinations().refs[kind];

  const syncedRef = useSyncRefs(ref, contextRef);

  const cx = useMemo(() => classNames.bind(styles), [styles]);

  return (
    <div ref={syncedRef} className={cx("wrapper", `cards-${toRender}`)}>
      {Array.from({ length: toRender }).map((_, index) => (
        <div
          style={calculatePosition?.(index)}
          key={index}
          id={`destination-${kind}-${index}`}
          className={cx("destination")}
        >
          {destinationChild}
        </div>
      ))}
      {wrapperChild}
    </div>
  );
});
